import styled from "styled-components";

export default styled.div`
	color: white;
	padding: 4px;
	text-align: center;
	text-transform: uppercase;
	font-size: 12px;
	letter-spacing: 1.8px;
`;
